export function calculateDateDifference (startDate, endDate) {
  const dt1 = new Date(startDate);
  const dt2 = new Date(endDate);
  const startUTCDate = Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate());
  const endUTCDate = Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate());

  return Math.floor(( startUTCDate - endUTCDate ) / (1000 * 60 * 60 * 24));
};

export function createMarkup (html) {
  return {
    __html: `${html}`
  };
};